<template>
  <div class="tableContainer">
    <table>
      <thead>
        <td v-for="header in headers">{{ header }}</td>
      </thead>
      <tbody>
        <tr
          v-for="row in data"
          :key="row"
          :class="getRowClass(row)"
          @click="$emit('toggleModal', row)"
        >
          <td>{{ row.week }}</td>
          <td>{{ row.date.toLocaleDateString() }}</td>
          <td>{{ row.ptoHours }}</td>
          <td>{{ row.remainingHours }}</td>
          <td>{{ row.notes }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TextInput from "./TextInput.vue";

export default {
  components: {
    TextInput,
  },

  props: {
    headers: Array,
    data: Array,
  },

  methods: {
    getRowClass(row) {
      const today = new Date();
      const d = new Date(row.date);
      const dAdd5 = new Date(row.date);
      dAdd5.setDate(d.getDate() + 5);

      if (row.remainingHours < 0) return "error";

      if (row.ptoHours && d >= today) return "planned";
      if (row.ptoHours && d < today) return "taken";

      if (d <= today && dAdd5 >= today) return "present";
      if (d < today) return "past";
      else return "future";
    },
  },
};
</script>

<style scoped>
.tableContainer {
  margin-top: 2rem;

  & table {
    width: 100%;
    & thead {
      & td {
        font-weight: bold;
        color: white;
        padding: 0.5rem;
      }
    }

    & tbody {
      & tr {
        color: white;
        cursor: pointer;

        &:nth-of-type(odd) {
          background-color: var(--vt-c-black-soft);
        }

        &:nth-of-type(even) {
          background-color: var(--vt-c-black-mute);
        }

        &:hover {
          background-color: var(--vt-c-pink-soft);
        }

        & td {
          font-weight: bold;
          padding: 0.5rem;
        }

        &.planned,
        &.taken {
          color: var(--vt-c-pink);
        }

        &.past {
          color: var(--vt-c-blue);
        }

        &.present {
          color: var(--vt-c-green);
        }

        &.error {
          color: var(--vt-c-red);
        }
      }
    }
  }
}
</style>
